import React from 'react';
import { UnitConverter } from './UnitConverter';

// Non-linear - use toBase / fromBase functions. Base = Celsius.
const units = [
  { key: 'c', label: 'Celsius (°C)',    toBase: (v) => v,            fromBase: (v) => v },
  { key: 'f', label: 'Fahrenheit (°F)', toBase: (v) => (v - 32) / 1.8, fromBase: (v) => v * 1.8 + 32 },
  { key: 'k', label: 'Kelvin (K)',      toBase: (v) => v - 273.15,   fromBase: (v) => v + 273.15 },
];

export const ConvTemp = () => (
  <UnitConverter
    title="Temperature"
    units={units}
    explanationTitle="Units of temperature"
    explanation="F = 9/5 × C + 32. The English system typically measures temperature in Fahrenheit; this equation converts it to Celsius. For example, 10°F equals −12.22°C."
  />
);
